export default __webpack_public_path__ + "static/media/lavagnanag.682e40a3.avif";